export enum BulkOperationType {
  EnableSubscriptions = 'EnableSubscriptions',
  DisableSubscriptions = 'DisableSubscriptions'
}
